import LoginSendCode from 'assets/images/auth/Group 392.svg'
interface IConfirmationHeaderProps {
    phone: string
}
export default function ConfirmationHeader({
    phone,
}: IConfirmationHeaderProps) {
    return (
        <div className=" mt-16">
            <img
                alt="login send code"
                src={LoginSendCode}
                className="block m-auto mb-10 w-32"
            />
            <p className="text-center mt-4 text-green-1 text-xl  mb-3 ">
                ورود کد تایید
            </p>
            <p className=" text-center text-sm mb-4 ">
                کد تایید ارسال شده به شماره‌
                {` ${phone ? phone : ''} `}
                را وارد نمایید
            </p>
        </div>
    )
}
